import { QueryParameters as BrandPageQueryParams } from "@faire/web-api/routes/brand/brandToken";
import { Button } from "@faire/web/slate/Button";
import { ShipsFrom } from "@faire/web/slate/icons/foundation/ShipsFrom";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { Suspense, useState } from "react";

import { LazyRetailerReportBrandModal } from "@faire/retailer/views/brand/ReportBrandIssues/RetailerReportBrandModal";

interface IProps {
  brandToken: string | undefined;
  productToken?: string | undefined;
}

const REPORT_ISSUE_MOBILE_WEBVIEW = "openIssueReport";

export const ReportBrandIssuesButton: React.FC<IProps> = (props) => {
  /**
   * When reporting an issue on the native mobile apps, the current solution is to
   * launch a webview to the web issue reporting flow. Since this lives in a set of modals
   * that do not have their own unique URL, we use the presence of this query param to
   * 1. automatically open the issue reporting modal
   * 2. hide the functionality for closing the modal (since the webview has its own 'Done' button)
   */
  const queryParams = useQueryParams(BrandPageQueryParams.parse);
  const isMobileWebview = REPORT_ISSUE_MOBILE_WEBVIEW in queryParams;

  const [showModal, setShowModal] = useState(isMobileWebview);

  const toggleModal = () => {
    setShowModal((s) => !s);
  };

  return (
    <Row align="center">
      <ShipsFrom />
      <Spacer width={4} />
      <Button variant="tertiary" onClick={toggleModal}>
        <StrictLocalMsg
          defaultMessage="Report this brand"
          description={{
            text: "Button to let retailers report brand, in sentence case",
            img: "https://cdn.faire.com/fastly/9eb382a13583fe4fcc611092f78a93fd5cacc3d449659483d0efbacc97ef1db6.png",
          }}
        />
      </Button>
      {showModal ? (
        <Suspense fallback={null}>
          <LazyRetailerReportBrandModal
            brandToken={props.brandToken}
            onClose={isMobileWebview ? null : toggleModal}
            productToken={props.productToken}
            isMobileWebview={isMobileWebview}
          />
        </Suspense>
      ) : null}
    </Row>
  );
};
